import("https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs").then(
  (_ref) => {
    let { Swiper, Navigation } = _ref;
    Swiper.use([Navigation]);
    const swipperFeatured = new Swiper(".article-slider__swiper", {
      slidesPerView: 1,
      spaceBetween: 0,
      keyboard: {
        enabled: true,
      },
      breakpoints: {
        650: {
          slidesPerView: 2,
        },
        900: {
          slidesPerView: 3,
        },
      },
      navigation: {
        nextEl: ".article-slider__button-next",
        prevEl: ".article-slider__button-prev",
      },
    });
  }
);
